import { render } from "./SelectedList.vue?vue&type=template&id=2c11665d&scoped=true"
import script from "./SelectedList.vue?vue&type=script&lang=js"
export * from "./SelectedList.vue?vue&type=script&lang=js"

import "./SelectedList.vue?vue&type=style&index=0&id=2c11665d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c11665d"]])

export default __exports__